import { Card, SectionLabel } from '@/components/ui';
import { pillars } from '@/content/pillars';
import { C } from '@/theme/tokens';

/** "What Is QuestXR" section: header, lede, and 3 pillar cards. */
export function WhatIsSection() {
  return (
    <section id="what-is-questxr" style={{ background: '#0a1a2a', padding: '36px 24px' }}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 64 }}>
          <SectionLabel>What is QuestXR</SectionLabel>
          <h2
            style={{
              fontFamily: "'Cinzel',serif",
              fontSize: 'clamp(1.6rem,4vw,2.4rem)',
              fontWeight: 700,
              letterSpacing: '1.5px',
              color: '#fff',
              textTransform: 'uppercase',
              marginBottom: 16,
            }}
          >
            Multi-Genre RPG. Real World. <span style={{ color: C.gold }}><br />Infinite Stories.</span>
          </h2>
          <p
            style={{
              maxWidth: 580,
              margin: '0 auto',
              color: 'rgba(255,255,255,0.6)',
              fontSize: 16,
              lineHeight: 1.7,
            }}
          >
            QuestXR is the first tabletop RPG experience you play with not just with your mind, but also with your body. Leave the table behind — the world is the dungeon.
          </p>
        </div>

        <div
          className="feature-grid"
          style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 24 }}
        >
          {pillars.map(({ icon, title, desc }) => (
            <Card key={title} glow style={{ padding: '36px 28px' }}>
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
                <img src={icon} alt={title} style={{ width: 72, height: 72, objectFit: 'contain' }} />
              </div>
              <h3
                style={{
                  fontFamily: "'Cinzel',serif",
                  fontSize: 17,
                  fontWeight: 700,
                  letterSpacing: '1px',
                  color: C.gold,
                  textTransform: 'uppercase',
                  marginBottom: 10,
                }}
              >
                {title}
              </h3>
              <p
                style={{
                  fontSize: 14,
                  color: 'rgba(255,255,255,0.65)',
                  lineHeight: 1.7,
                  fontWeight: 300,
                }}
              >
                {desc}
              </p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
